import { flow, Instance, types } from 'mobx-state-tree'
import { addPackageToInstrument } from '../../network/addPackageToInstrument'
import { deletePackageToInstrument } from '../../network/deletePackageToInstrument'
import { getAllPackageToInstruments } from '../../network/getAllPackageToInstruments'
import { getPackageToInstrumentById } from '../../network/getPackageToInstrumentById'
import { p2IProcessApprovals } from '../../network/p2IProcessApprovals'
import { updatePackageToInstrument } from '../../network/updatePackageToInstrument'
import { getErrorMessage, MessageTypes } from '../../utils'
import { FORM_MESSAGE } from '../../utils/constants'
import { RootStore } from '../store'

const Instrument = types.model('Instrument', {
  type: types.optional(types.literal('package2Instrument'), 'package2Instrument'),
  id: types.maybeNull(types.number),
  packageName: types.optional(types.string, ''),
  instrument: types.optional(types.string, ''),
  fileName: types.optional(types.string, ''),
  isGenerated: types.optional(types.string, 'N'),
})

const PackageToInstrument = types
  .model('PackageToInstrument', {
    instrument: types.optional(Instrument, {}),
    instruments: types.array(Instrument),
  })
  .actions((self) => ({
    getAll: flow(function* getAll() {
      try {
        const response = yield getAllPackageToInstruments(RootStore.session.getTokens)
        const own = self
        own.instruments = response
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    getById: flow(function* getById(id: string) {
      try {
        const response = yield getPackageToInstrumentById(id, RootStore.session.getTokens)
        const own = self
        own.instrument = response
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
    add: flow(function* add(data: any) {
      try {
        const response = yield addPackageToInstrument(data, RootStore.session.getTokens)
        RootStore.message.setMessage(response?.message, MessageTypes.SUCCESS)
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR, FORM_MESSAGE)
        throw error
      }
    }),
    update: flow(function* update(data: any) {
      try {
        const response = yield updatePackageToInstrument(data, RootStore.session.getTokens)
        RootStore.message.setMessage(response?.message, MessageTypes.SUCCESS)
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR, FORM_MESSAGE)
        throw error
      }
    }),
    deletePackage: flow(function* deletePackage(data: any) {
      try {
        const response = yield deletePackageToInstrument(data, RootStore.session.getTokens)
        RootStore.message.setMessage(response?.message, MessageTypes.SUCCESS)
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR, FORM_MESSAGE)
        throw error
      }
    }),

    processApprovals: flow(function* processApprovals(data: any) {
      try {
        const response = yield p2IProcessApprovals(data, RootStore.session.getTokens)
        RootStore.message.setMessage(response?.message, MessageTypes.SUCCESS)
        return response
      } catch (error) {
        RootStore.message.setMessage(getErrorMessage(error), MessageTypes.ERROR)
        throw error
      }
    }),
  }))

const packageInstrumentData = PackageToInstrument.create({
  instrument: {},
  instruments: [],
})

export type PackageToInstrumentType = Instance<typeof PackageToInstrument>

export { Instrument, PackageToInstrument, packageInstrumentData }
